import AgeFilterComponent, { OtherAgeElementType } from "./components/ageFilterComponent";
import GenderFilterComponent from "./components/genderFilterComponent";
import {useSelector,useDispatch} from 'react-redux'
import './filterWrapperStyle.css'
import { getEvdaEuropeAgeFilterState, getEvdaEuropeDateFilterState, getEvdaEuropeGenderFilterState } from "../../redux/selectors/filterSelector";
import { SelectedAge } from "../../models/SelectedAge";
import { FilterAction } from "../../redux/states/filterState";
import { SelectedGender } from "../../models/SelectedGender";
import DateFilterComponent from "./components/dateFilterComponent";
import CountrySelectionComponent from "./components/countrySelectionComponent";
import {MapPoint} from "../../service/MapPoint";
export type Props = {
    maxDate: number,
    data: MapPoint[]
}
const EvdaEuropeFilterWrapper:React.FC<Props>=({maxDate, data})=>{
        const dispatch = useDispatch()
        const agerFilter = useSelector(getEvdaEuropeAgeFilterState)
        const genderFilter = useSelector(getEvdaEuropeGenderFilterState)
        const dateFilter = useSelector(getEvdaEuropeDateFilterState)
        const onsetAgeSelectionHandler=(selection:SelectedAge)=>{
            dispatch(FilterAction.SetEvdaEuropeAgeSelection(selection))
        } 
        const onSetGenderSelection=(gender:SelectedGender) =>{
            dispatch(FilterAction.SetEvdaEuropeGenderInSelection(gender))
        }
        const onSetYearSelection =(year: number)=>{
            dispatch(FilterAction.setEvdaEuropeSelectedYear(year))
        }

       
    return(<>
        <AgeFilterComponent 
            selectedAge={agerFilter.seletedAge} 
            customAgeElement={OtherAgeElementType.none} 
            customSelectedAge={agerFilter.customSelectedAge}
            onSetSelection={onsetAgeSelectionHandler}/>
        <GenderFilterComponent 
            selectedGender={genderFilter.selectedGender} 
            setSelectectionHandler={onSetGenderSelection}/>
        <CountrySelectionComponent data={data}></CountrySelectionComponent>
        <DateFilterComponent minValue={2004} maxValue={maxDate} selectedYear={dateFilter.selectedyear} setSelectedYearHandler={onSetYearSelection}/>
        </>)
}

export default EvdaEuropeFilterWrapper;